<script setup lang="ts">
import { breakpointsTailwind } from '@vueuse/core'
import { NLayout, NLayoutSider, NWatermark } from 'naive-ui'

const { isSmallerOrEqual } = useBreakpoints(breakpointsTailwind)
const siderCollapsed = ref(isSmallerOrEqual('sm'))
const config = useRuntimeConfig()

const runSystemString = computed(() => config.public.runSystem)

const isGlobalSearchOpen = ref(false)
</script>

<template>
  <NLayout :has-sider="true" position="absolute">
    <NLayoutSider
      :collapsed="siderCollapsed"
      :bordered="true"
      :show-trigger="true"
      collapse-mode="width"
      :collapsed-width="64"
      :width="270"
      :native-scrollbar="false"
      content-class="h-full"
      class="z-2"
      @collapse="siderCollapsed = true"
      @expand="siderCollapsed = false"
    >
      <NWatermark
        :content="runSystemString"
        class="h-full"
        cross
        selectable
        :font-size="12"
        :line-height="12"
        :width="120"
        :height="100"
        :x-offset="10"
        :y-offset="20"
        :rotate="-10"
      >
        <div class="flex flex-col justify-between h-full">
          <div class="flex-0">
            <Account :collapsed="siderCollapsed" />
            <div v-if="$can('read', 'global-search')" class="p-2">
              <GlobalSearch v-model:show="isGlobalSearchOpen">
                <template v-if="siderCollapsed" #trigger>
                  <NTooltip>
                    <template #trigger>
                      <NButton quaternary block @click="isGlobalSearchOpen = true">
                        <template #icon>
                          <UIcon name="i-ic-baseline-search" />
                        </template>
                      </NButton>
                    </template>
                    <span>Tippe <UKbd>/</UKbd> für die Suche</span>
                  </NTooltip>
                </template>
              </GlobalSearch>
            </div>
          </div>
          <NScrollbar class="max-h-full flex-1 shrink-0" trigger="none">
            <SidebarMenu />
          </NScrollbar>
          <div class="flex flex-col p-2 flex-0">
            <TimeTrackerTaskQuickStartPanel v-show="!siderCollapsed" />
            <ClientOnly>
              <TimeTracker :collapsed="siderCollapsed" />
            </ClientOnly>
          </div>
        </div>
      </NWatermark>
    </NLayoutSider>
    <slot />
  </NLayout>
</template>
